import React, { useState } from 'react'
import '../scss/search.scss'
import ReactTooltip from 'react-tooltip'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faFilter } from '@fortawesome/free-solid-svg-icons';

interface IProps {
    setNodata: React.Dispatch<React.SetStateAction<boolean>>,
    title: string,
    disabled: boolean
    callbackSearch: Function
    callbackFilter: Function

}

const Search = ({ setNodata, callbackSearch, callbackFilter, disabled, title }: IProps) => {

    const [optSearch, setOptSearch] = useState(false);

    const [search, setSearch] = useState(false);
    const [query, setQuery] = useState('');
    const [filter, setFilter] = useState(false);


    const onSetQuey = (e: any) => setQuery(e.target.value);

    const Submit = (e: any) => {
        e.preventDefault();
        onSearch()
    }

    const onSearch = async () => {
        setSearch(true);
        setNodata(true);
        await callbackSearch(query, true);
    };

    const onClear = async (e: any) => {
        e.preventDefault();
        setSearch(false);
        setNodata(false)
        setQuery('');
        await callbackSearch(query, false);
    };

    const onFilter = async (f: any) => {
        setFilter(!f);
        await callbackFilter(!f);
    };

    return (
        <div className="contTirepN">
            <div className="nameRep">
                {title}
            </div>
            <div className="icRep">
                <div className="firstdiv">
                    {
                        <div className="contInp" style={{ display: `${optSearch ? 'flex' : 'none'}` }}>
                            <label>
                                <form onSubmit={search ? onClear : Submit}>
                                    <input
                                        value={query}
                                        name="asd"
                                        onChange={onSetQuey}
                                        type="text"
                                        placeholder="Buscar ..."
                                        disabled={search || disabled}
                                        required
                                    />
                                    <button type="submit" disabled={disabled}>
                                        {
                                            search ? 'Borrar' : 'Buscar'
                                        }
                                    </button>
                                </form>
                            </label>
                            <button
                                className="btnclose"
                                onClick={() => setOptSearch(false)}
                                disabled={disabled}
                                data-tip="Cerrar"
                            >
                                <i className="fas fa-times" />
                            </button>
                        </div>
                    }
                    {
                        <button
                            style={{ display: `${optSearch ? 'none' : 'block'}` }}
                            onClick={() => setOptSearch(true)}
                            disabled={disabled}
                            data-tip="Buscar"
                        >
                            <FontAwesomeIcon icon={faSearch} style={{ color: 'red' }} />
                            <i className={`fas fa-search ${optSearch ? 'active' : ''}`} />
                        </button>
                    }
                </div>
                <button
                    onClick={() => onFilter(filter)}
                    disabled={disabled}
                    data-tip="Filtrar"
                >
                    <FontAwesomeIcon icon={faFilter} className={`fas fa-filter ${filter ? 'active' : ''}`} />
                    {/* <i className={`fas fa-filter ${filter ? 'active' : ''}`} /> */}
                </button>
            </div>
            <ReactTooltip className="tolltip" effect='solid' place="top" />
        </div>
    )
}

export default Search
